import { LoaderCircle } from 'lucide-react';

export function Chargement({ plein = true }: { plein?: boolean }) {
  return (
    <div
      className={plein ? 'grid min-h-full place-items-center p-6' : 'grid place-items-center py-14'}
    >
      <LoaderCircle className="size-7 animate-spin text-primary" aria-label="Chargement" />
    </div>
  );
}
